module.exports = __webpack_public_path__ + "images/avatars/female/15.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/15.png
// module id = sNLF
// module chunks = 51